const STORAGE_KEY = 'dealzy_recently_viewed';
// Capped to match the backend's GetAdsByIds limit (Take(50)) so nothing is silently dropped there.
const MAX_ITEMS = 50;
const RETENTION_DAYS = 30;
const STRIP_LIMIT = 15;

function readAll() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : [];
    } catch {
        return [];
    }
}

function writeAll(items) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch { /* localStorage unavailable or full - ignore */ }
}

// Records a view: dedupes, moves to front, caps list length. Call once the ad has loaded.
export function addRecentlyViewed(adId) {
    if (!adId) return;
    const items = readAll().filter(item => item.id !== adId);
    items.unshift({ id: adId, viewedAt: Date.now() });
    writeAll(items.slice(0, MAX_ITEMS));
}

function withinRetention(item) {
    return Date.now() - item.viewedAt <= RETENTION_DAYS * 24 * 60 * 60 * 1000;
}

// Returns ids, most-recently-viewed first, optionally excluding one (e.g. the ad currently open).
export function getRecentlyViewedIds(excludeId) {
    return readAll()
        .filter(item => item.id !== excludeId && withinRetention(item))
        .map(item => item.id);
}

// Ids for the homepage strip, capped to STRIP_LIMIT.
export function getRecentlyViewedStripIds(excludeId) {
    return getRecentlyViewedIds(excludeId).slice(0, STRIP_LIMIT);
}

export { STRIP_LIMIT, RETENTION_DAYS };
